import React from "react";

const Card = ({
  onNavigation,
  card,
  quietStatus,
  sequence,
  currentIndex,
  imageHeight,
  imageWidth,
}) => {
  const handleNextClick = (e) => {
    e.preventDefault();
    onNavigation(1);
  };

  const identifier = `${currentIndex.flow}-${currentIndex.section + 1}`;

  const renderedText = () => {
    if (card.text) {
      return (
        <p
          style={{
            fontSize: imageWidth * 0.010446705710102488,
          }}>
          {card.text}
        </p>
      );
    }
  };

  const renderCardClasses = () => {
    let cardClasses = "app-card";
    if (quietStatus && card.text) {
      cardClasses = cardClasses + "";
    } else {
      cardClasses = cardClasses + " hidden";
    }
    if (card.snack.isVisible) {
      cardClasses = cardClasses + ` snack-${card.snack.position}`;
    }
    if (sequence) {
      cardClasses = cardClasses + " delay";
    } else {
      cardClasses = cardClasses + " no-delay";
    }
    if (!card.snack.isVisible) {
      cardClasses = cardClasses + " " + card.beacon.position;
    }
    return cardClasses;
  };

  const getRandomKey = () => {
    return Math.random();
  };

  if (card.snack.isVisible) {
    return (
      <div
        key={getRandomKey()}
        className={renderCardClasses()}
        style={{
          width: imageWidth * 0.2,
          //padding: imageWidth * 0.012315265486725662,
          padding: imageWidth * 0.01001,
          top: card.position.y,
        }}>
        <div className="content">{renderedText()}</div>
      </div>
    );
  } else {
    return (
      <div
        key={getRandomKey()}
        className="app-beacon-container"
        style={{
          top: card.position.y,
          left: card.position.x,
        }}>
        <button
          onClick={handleNextClick}
          data-identifier={identifier}
          className={`beacon${card.beacon.isVisible ? "" : " hidden"}${
            sequence ? " delay" : " no-delay"
          }`}
          aria-label="Navigate to Next Page"></button>
        <div
          className={renderCardClasses()}
          style={{
            width: imageWidth * 0.2,
            padding: imageWidth * 0.012315265486725662,
          }}>
          <div className={`caret ${card.beacon.position}`}></div>
          <div className="content">{renderedText()}</div>
        </div>
      </div>
    );
  }
};

export default Card;
